<template>
  <Button
    label="Отказ"
    icon="pi pi-times"
    class="p-button-secondary"
    @click="$emit('cancel')"
  />
  <Button
    v-bind:label="labelOk"
    :icon="'pi pi-check'"
    class="p-button-primary"
    @click="$emit('apply')"
    :disabled="blockOk"
  />
  <!--  -->
</template>

<script>
export default {
  emits: {
    cancel: null,
    apply: null
  },
  props: {
    labelOk: {
      type: String,
      default: function() {
        return "Запис";
      }
    },
    blockOk: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    saving: {
      type: Boolean,
      default: function() {
        return false
      }
    }
  },
  data() {
    return {
    }
  },

}
</script>